import { render, staticRenderFns } from "./appltTemplate.vue?vue&type=template&id=9a58050e&scoped=true"
import script from "./appltTemplate.vue?vue&type=script&lang=js"
export * from "./appltTemplate.vue?vue&type=script&lang=js"
import style0 from "./appltTemplate.vue?vue&type=style&index=0&id=9a58050e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a58050e",
  null
  
)

export default component.exports